import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { GrupoProdutoAtualizar, GrupoProdutoCadastrar } from '../../../../routes/RoutesNames';
import { useSelector } from 'react-redux';
import GrupoProdutoController from '../../../../controllers/GrupoProdutoController';
import { Button } from '../../../../shared/components/button/Button';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { toast } from 'react-toastify';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu'
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  grp_id: number;
  grp_siglaid: string;
  grp_descricao: string;
}

export default function GrupoProduto() {
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const tableColumns: Column[] = [
    { id: 'Id', label: 'Sigla', minWidth: 0, align: 'center' },
    { id: 'Descricao', label: 'Descrição', minWidth: 0 },
    { id: 'Codigo', label: 'Código', minWidth: 0, hidden: true },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];
  const fields = [
    { name: 'SiglaID', label: 'Sigla', type: 'text', col: 3 },
    { name: 'Descricao', label: 'Descrição', type:'text', col: 3 },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />), col: 1 }
  ];
  const [tableRows, setTableRows] = useState<Row[]>([]);
  const initialValues = {
    SiglaID: null,
    Descricao: '',
    Codigo: ''
  };

  const handleNavigation = async (): Promise<void> => {
    navigate(GrupoProdutoCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      console.log("duploClickID: ", duploClickId);
      navigate(GrupoProdutoAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else{
      console.log("btnEdit: ", item.grp_id);
      navigate(GrupoProdutoAtualizar.replace(':id', item.grp_id.toString()));
    }
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    console.log("values do submit");
    console.log(values);
    const Response = await GrupoProdutoController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          Id: item.grp_siglaid,          
          Descricao: item.grp_descricao,
          Codigo: item.grp_id,
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: "Editar" },
                { onClick: () => handleDeleteItem(item.grp_id), menu: "Excluir", confirmar: `Excluir o grupo de produto "${item.grp_descricao ?? ''}"? Esta ação não pode ser desfeita.` },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'error',
      });
    }
  };

  const handleDeleteItem = async (grp_id: number) => {
    const request: any = { UsuId: userId, GrupoProdutoId: grp_id };
    const response = await GrupoProdutoController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Grupo produto excluído com sucesso!', {
        type: 'success',
      });
      handleSubmit(initialValues);
    } else {
      toast('Erro ao excluir o grupo produto!', {
        type: 'error',
      });
    }
  };

  useEffect(() => {
    handleSubmit(initialValues)
  }, []);

  return (
    <Box>
      <HeaderComponent
        text={'GRUPOS PRODUTOS'}
        ButtonRight={
          <Button
            className={''}
            variant='success'
            onClick={handleNavigation}
            iconStart={<Icon.Add />}
            title={'Incluir'}
          />
        }
      />
      <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} gap='gap-3' />
      <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Codigo);}}/>
    </Box>
  );
}